import type { EncodeStatusEnum } from '@frameio/graphql-client/generated/types';
import type { LocaleKey } from '../LanguageMenu';

export type TranscriptionLike = {
  encodeStatus?: EncodeStatusEnum;
  [key: string]: unknown;
};

export const checkIfTranscriptionGenerating = (
  transcriptions?: TranscriptionLike[]
) => {
  if (!transcriptions) return false;
  return (
    transcriptions.find(
      (node: TranscriptionLike) => node?.encodeStatus === 'STARTED'
    ) || false
  );
};

export const checkIfTranscriptionHasError = (
  transcriptions: TranscriptionLike[],
  language: LocaleKey
) => {
  if (!transcriptions) return false;
  return transcriptions.some(
    (node: TranscriptionLike) =>
      node?.encodeStatus === 'FAILURE' && node?.locale === language
  );
};
